import React from 'react';

import { ListHookResult, transformListData } from '_lib/api/apiResourceFactory';

import { Card } from '_lib/components/Card/Card';
import { CardContent } from '_lib/components/CardContent/CardContent';
import { Typography } from '_lib/components/Typography/Typography';

import { Box } from '../../components/Box/Box';
import { Button } from '../../components/Button/Button';
import { List } from '../../components/List/List';

interface PagedListProps<TListDTO> {
  queryResult: ListHookResult<TListDTO>;
  renderFunction: (item: TListDTO) => React.ReactElement;
  filterFunction?: (item: TListDTO) => boolean;
  emptyListMessage?: string;
  /** In some cases, we want to display paged lists similarly to unpaged ones */
  disableShowMore?: boolean;
}

export const PagedList = <TListDTO extends { id: string } | { providerId: string }>(
  props: PagedListProps<TListDTO>
): React.ReactElement => {
  const { renderFunction, queryResult, filterFunction, emptyListMessage, disableShowMore } = props;

  const { data, fetchNextPage, hasNextPage, isFetching } = queryResult;

  const transformedData = transformListData(data).filter(filterFunction ? filterFunction : () => true);

  if (!transformedData.length && !isFetching) {
    return (
      <Card variant='outlined' sx={{ display: 'flex', justifyContent: 'center' }}>
        <CardContent sx={{ padding: 2 }}>
          <Typography text={emptyListMessage || 'No Items were found.'} />
        </CardContent>
      </Card>
    );
  }

  return (
    <Box>
      <List sx={{ paddingTop: 0 }}>{transformedData.map((item) => renderFunction(item))}</List>
      {hasNextPage && !disableShowMore && (
        <Button
          fullWidth
          color='primary'
          text='Show More Results'
          onClick={() => {
            fetchNextPage();
          }}
        />
      )}
    </Box>
  );
};
